import { useEffect } from 'react';
import Cookies from 'js-cookie';

export const useUserActivity = (isAuthenticated = false) => {
  useEffect(() => {
    // No hacer nada si el usuario no está autenticado
    if (!isAuthenticated) {
      return;
    }

    let activityInterval;
    let logoutTimeout;

    const updateActivity = async () => {
      try {
        const activityResponse = await fetch('/api/audit/update-activity', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            currentPage: window.location.pathname
          })
        });

        if (!activityResponse.ok) {
          throw new Error(`HTTP error! status: ${activityResponse.status}`);
        }
      } catch (error) {
        console.error('Error updating user activity:', error);
      }
    };

    const performLogout = () => {
      // Cierre local por inactividad. El endpoint de logout se usa solo en el botón de cerrar sesión.
      localStorage.removeItem('userData');
      Object.keys(Cookies.get()).forEach(cookieName => {
        Cookies.remove(cookieName, { path: '/' });
      });
      window.location.href = '/admin/login';
    };

    // Registrar actividad inicial
    updateActivity();

    // Registrar actividad cada 30 segundos
    activityInterval = setInterval(updateActivity, 30000);

    // Logout automático después de 1 hora de inactividad
    const resetLogoutTimer = () => {
      if (logoutTimeout) {
        clearTimeout(logoutTimeout);
      }
      logoutTimeout = setTimeout(performLogout, 60 * 60 * 1000); // 1 hora
    };

    // Resetear timer en eventos de actividad
    const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    activityEvents.forEach(event => {
      document.addEventListener(event, resetLogoutTimer, true);
    });

    // Iniciar timer de logout
    resetLogoutTimer();

    return () => {
      if (activityInterval) {
        clearInterval(activityInterval);
      }
      if (logoutTimeout) {
        clearTimeout(logoutTimeout);
      }
      activityEvents.forEach(event => {
        document.removeEventListener(event, resetLogoutTimer, true);
      });
    };
  }, [isAuthenticated]); // ✅ Agregar isAuthenticated como dependencia
};
